import React, { useState, useEffect } from "react";
import axios from "axios";

const Payment = () => {
  const [payments, setPayments] = useState([]);
  const [selectedImage, setSelectedImage] = useState(null); // 🔍 preview state
  const API_BASE = import.meta.env.VITE_API_BASE_URL;

  const fetchPayments = async () => {
    try {
      const res = await axios.get(`${API_BASE}/api/payments`);
      setPayments(res.data);
      
    } catch (error) {
      console.error("Failed to fetch payments", error);
    }
  };

  useEffect(() => {
    fetchPayments();
  }, []);

  const handleDelete = async (id) => {
    if (!confirm("Are you sure you want to delete this payment?")) return;

    try {
      await axios.delete(`${API_BASE}/api/payments/${id}`);
      fetchPayments();
    } catch (error) {
      console.error("Failed to delete payment", error);
    }
  };

  return (
    <div className="w-full flex flex-col gap-8">
      <div className="w-full flex flex-col gap-4 bg-[#00294B] rounded-md">
        <h2 className="px-4 pt-4 text-2xl font-bold text-white">Payments</h2>

        <div className="w-full flex flex-col gap-4 p-4 min-h-[20rem]">
          {payments.length === 0 ? (
            <h4 className="text-xl font-semibold text-white text-center">
              No payments found.
            </h4>
          ) : (
            <div className="overflow-x-auto">
              <table className="min-w-full bg-[#022C4E] text-white rounded-md overflow-hidden">
                <thead>
                  <tr className="bg-[#00406B] text-left">
                    <th className="py-3 px-4">ID</th>
                    <th className="py-3 px-4">Name</th>
                    <th className="py-3 px-4">Email</th>
                    <th className="py-3 px-4">Number</th>
                    <th className="py-3 px-4">Title</th>
                    <th className="py-3 px-4">Amount</th>
                    <th className="py-3 px-4">Screenshot</th>
                    <th className="py-3 px-4">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {payments.map((pay) => (
                    <tr key={pay.id} className="border-b border-[#1a3c5a]">
                      <td className="py-3 px-4">{pay.id}</td>
                      <td className="py-3 px-4">{pay.name}</td>
                      <td className="py-3 px-4">{pay.email}</td>
                      <td className="py-3 px-4">{pay.number}</td>
                     
                     <td className="py-3 px-4">
                      {(() => {
                        try {
                          const item = JSON.parse(pay.items);
                          return item.name || item.title || '';
                        } catch (e) {
                          return 'N/A';
                        }
                      })()}
                    </td>
                     <td className="py-3 px-4">{pay.items ? JSON.parse(pay.items).current_price : 'N/A'}</td>
                      <td className="py-3 px-4">
                        {pay.screenshot_path ? (
                          <img
                            src={`${API_BASE}/storage/${pay.screenshot_path}`}
                            alt="Screenshot"
                            className="w-16 h-16 object-cover rounded cursor-pointer"
                            onClick={() =>
                              setSelectedImage(
                                `${API_BASE}/storage/${pay.screenshot_path}`
                              )
                            }
                          />
                        ) : (
                          <span className="text-gray-400">No Screenshot</span>
                        )}
                      </td>
                      <td className="py-3 px-4">
                        <button
                          onClick={() => handleDelete(pay.id)}
                          className="bg-red-600 hover:bg-red-700 text-white py-1 px-3 rounded"
                        >
                          Delete
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>

      {/* 🔍 Modal for full-size image */}
      {selectedImage && (
        <div
          className="fixed inset-0 bg-black bg-opacity-75 flex justify-center items-center z-50"
          onClick={() => setSelectedImage(null)} // close when clicking outside
        >
          <img
            src={selectedImage}
            alt="Full Preview"
            className="max-w-[90%] max-h-[90%] rounded shadow-lg border-4 border-white"
            onClick={(e) => e.stopPropagation()} // prevent close on image click
          />
          <button
            onClick={() => setSelectedImage(null)}
            className="absolute top-4 right-4 text-white text-3xl font-bold"
          >
            &times;
          </button>
        </div>
      )}
    </div>
  );
};

export default Payment;
